import { useAppSelector } from "../hooks";

export const useGetInterests = () => {
  const getInterests = useAppSelector(({ content }) => content.getInterests);

  return getInterests;
};

export const useSetInterests = () => {
  const setInterests = useAppSelector(({ content }) => content.setInterests);

  return setInterests;
};

export const useAddBookmark = () => {
  const addBookmark = useAppSelector(({ content }) => content.addBookmark);

  return addBookmark;
};

export const useRemoveBookmark = () => {
  const removeBookmark = useAppSelector(
    ({ content }) => content.removeBookmark
  );

  return removeBookmark;
};

export const useGetHighlights = () => {
  const selectedContentHighlights = useAppSelector(
    ({ content }) => content.selectedContentHighlights
  );

  return selectedContentHighlights;
};

export const useCreateHighlight = () => {
  const createHighlight = useAppSelector(
    ({ content }) => content.createHighlight
  );

  return createHighlight;
};

export const useRemoveHighlight = () => {
  const removeHighlight = useAppSelector(
    ({ content }) => content.removeHighlight
  );

  return removeHighlight;
};

export const useGetDynamicLink = () => {
  const dynamicLink = useAppSelector(({ content }) => content.dynamicLink);

  return dynamicLink;
};

export const useGetNextContent = () => {
  const nextContent = useAppSelector(({ content }) => content.nextContent);

  return nextContent;
};

export const useSearchTracked = () => {
  const searchTracked = useAppSelector(({ content }) => content.searchTracked);

  return searchTracked;
};
